
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PostMetadataThemeSelectorProps {
  theme: string;
  setTheme: (theme: string) => void;
}

const PostMetadataThemeSelector: React.FC<PostMetadataThemeSelectorProps> = ({
  theme,
  setTheme,
}) => {
  // Available themes (can be expanded)
  const themes = [
    { id: "default", name: "Default" },
    { id: "elf-letter-bot", name: "Elf Letter Bot" },
    { id: "christmas", name: "Christmas" },
  ];

  return (
    <div className="space-y-2">
      <Label htmlFor="theme">Theme</Label>
      <Select value={theme} onValueChange={setTheme}>
        <SelectTrigger>
          <SelectValue placeholder="Select theme" />
        </SelectTrigger>
        <SelectContent>
          {themes.map((t) => (
            <SelectItem key={t.id} value={t.id}>
              {t.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PostMetadataThemeSelector;
